/**
 * One-time, in-app announcements shown to logged-in users.
 *
 * Each entry is shown once per user. Dismissals are recorded on the user's
 * Firestore document as `users/{uid}.announcementsSeen[id]`, so adding a future
 * announcement means appending an entry here with a NEW `id` and flipping the
 * previous entry's `active` to false. Never reuse an `id` for different copy —
 * users who dismissed the old one would never see the new one.
 *
 * Only the first entry with `active: true` is displayed.
 */
import { ESRI_CURRENT_YEAR, ESRI_PROJECTION_YEAR } from './esriDataVintage';

export const ANNOUNCEMENTS = [
  {
    id: 'esri-2026-demographics',
    version: 1,
    active: true,
    eyebrow: "What's new in School Explorer",
    title: `Refreshed Esri community data for ${ESRI_CURRENT_YEAR}`,
    body: [
      'See whether the school-age population around each of your schools is growing or shrinking, alongside refreshed Esri demographics and financial indicators like median household income, renters, poverty rate, and housing vacancies.',
      `Esri figures now reflect ${ESRI_CURRENT_YEAR} estimates with projections through ${ESRI_PROJECTION_YEAR}, under Your Community in the Geographic Explorer.`,
    ],
    ctaLabel: 'Explore the data',
    ctaPath: '/geographic-explorer',
    dismissLabel: 'Got it',
  },
];

export const getActiveAnnouncement = () =>
  ANNOUNCEMENTS.find((announcement) => announcement.active) || null;
